import { satisfies } from 'compare-versions';
import dayjs from 'dayjs';

import { Cluster } from '@cast/types';

import {
  isEKSCluster,
  isClusterOperable,
} from '@cast/shared-cluster-context-data-access';

// Need to update this on a regular basis when AWS updates calendar on their side
// until backend find a way to automate this :(
const K8S_VERSION_CALENDAR: Record<string, string> = {
  '2025-03-23': '1.30',
  '2024-11-26': '1.29',
  '2024-07-24': '1.28',
  '2024-06-11': '1.27',
  '2024-05-01': '1.26',
};

export const isClusterWithOldK8s = (cluster: Cluster): boolean => {
  const today = dayjs().startOf('day');
  const calendarKey = Object.keys(K8S_VERSION_CALENDAR).find((date) =>
    today.isSameOrAfter(date)
  );

  if (!calendarKey || !cluster.kubernetesVersion) {
    return false;
  }

  const supportedVersion = K8S_VERSION_CALENDAR[calendarKey];
  const isEKS = isEKSCluster(cluster);
  const isOperable = isClusterOperable(
    cluster,
    Boolean(cluster?.credentialsId)
  );
  const isOldK8s = satisfies(cluster.kubernetesVersion, `<${supportedVersion}`);

  return isEKS && isOperable && isOldK8s;
};
